<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Crowdtwist_Text_TokenInfo') }}
    </p>

    <integration-token-box :token="model.token" />

    <br />

    <p class="item-description">
      {{ $t('Integrations_Crowdtwist_Text_EndpointsInfo') }}
    </p>

    <el-table :data="tableData" stripe>
      <el-table-column
        prop="api"
        :label="$t('Integrations_Crowdtwist_Text_EndpointType')"
        width="180"
      />
      <el-table-column
        prop="endpoint"
        :label="$t('Integrations_Crowdtwist_Text_Endpoint')"
      />
    </el-table>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import IntegrationTokenBox from '@/modules/integrations/components/IntegrationTokenBox'

export default {
  name: 'CrowdtwistOverview',

  components: {
    FormSection,
    IntegrationTokenBox
  },

  props: {
    model: {
      required: false
    }
  },

  computed: {
    tableData() {
      let externalEndpoint = this.$store.state.app.domains.external_api
      return [
        {
          api: 'Activity',
          endpoint: externalEndpoint
            ? `https://${externalEndpoint}/api/integration/crowdtwist/handle-activity`
            : this.$t('Integrations_Text_NotSet')
        },
        {
          api: 'User Profile',
          endpoint: externalEndpoint
            ? `https://${externalEndpoint}/api/integration/crowdtwist/handle-user`
            : this.$t('Integrations_Text_NotSet')
        },
        {
          api: 'Redemption',
          endpoint: externalEndpoint
            ? `https://${externalEndpoint}/api/integration/crowdtwist/handle-redemption`
            : this.$t('Integrations_Text_NotSet')
        }
      ]
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/crowdtwist/CrowdtwistOverview.vue